import {
  PROFILE_ANALYT,
  SET,
  CHANNEL,
  REGION,
  REGION_LIST,
  VIEWERS,
  EVENTS,
  INTERVAL,
  SELECTOR,
  ACCOUNT,
  UNAUTHENTICATE,
  REQUEST,
  INFO,
} from '../common/dict';

import {
  createType,
  defineAsyncReducer,
  getInitState,
} from '../common/util';

const regionList = defineAsyncReducer(createType(PROFILE_ANALYT, REGION_LIST), 'region_list');

const viewers = defineAsyncReducer(createType(PROFILE_ANALYT, VIEWERS), 'viewers');
const events = defineAsyncReducer(createType(PROFILE_ANALYT, EVENTS), 'events');

const initialState = {
  selector: CHANNEL,
  channel: undefined,
  region: undefined,
  region_list: getInitState(),
  viewers: getInitState(),
  events: getInitState(),
  info: {
    selector: undefined,
    optionName: undefined,
  },
  interval: null,
};

const profile = (state = initialState, action) => {
  const { type, payload } = action;
  const initialValue = {
    [createType(UNAUTHENTICATE, REQUEST)]: () => initialState,
    [createType(SET, ACCOUNT)]: () => initialState,
    [createType(PROFILE_ANALYT, SET, SELECTOR, CHANNEL)]: () => ({ ...state, selector: CHANNEL }),
    [createType(PROFILE_ANALYT, SET, SELECTOR, REGION)]: () => ({ ...state, selector: REGION }),
    [createType(PROFILE_ANALYT, SET, CHANNEL)]: () => ({ ...state, channel: payload }),
    [createType(PROFILE_ANALYT, SET, REGION)]: () => ({ ...state, region: payload }),
    [createType(PROFILE_ANALYT, SET, INTERVAL)]: () => ({ ...state, interval: payload }),
    [createType(PROFILE_ANALYT, SET, INFO)]: () => ({ ...state, info: payload }),
  };
  const reducers = [regionList, viewers, events].reduce(
    (accumulator, currentValue) => currentValue(accumulator),
    initialValue,
  );
  if (type in reducers) {
    return reducers[type](state, action);
  }
  return state;
};

export default profile;
